export default "__VITE_ASSET__BA2zk1Hd__"